import React from 'react';
import {Table} from '../../../components/table/Table';
import {useInvoke} from '../../../controllers/useInvoke';

const TITLE = {
  field: 'single_screen_message_title',
  header: 'Title',
};

const URL = {
  field: 'single_screen_message_content',
  header: 'URL',
};

const CREATEDON = {
  type: 'date',
  field: 'created_on',
  header: 'Created On',
};

const COMPLETEDON = {
  type: 'date',
  field: 'completed_date',
  header: 'Completed On',
};

export const SingleScreenMessageActiveTable = props => {
  const {
    route: {params},
    navigation,
    searchValue,
  } = props;
  const {communicationFilter} = params;
  const invoke = useInvoke({method: 'put'});
  const markComplete = ({row}) => {
    invoke({
      uri: `/singlescreenmessages/${row?._id}`,
      props: {
        status: 'completed',
        completed_date: new Date(),
      },
    });
  };

  return (
    <Table
      search={searchValue}
      searchFields={'single_screen_message_title'}
      api={`/single-screen-message`}
      addOnFilter={{
        status: 'active',
        ...communicationFilter,
      }}
      params={params}
      onRowPress={row => {
        navigation.navigate('edit-single-screen-message', row);
      }}
      columns={[
        TITLE,
        URL,
        CREATEDON,
      ]}
      moreActions={[
        {
          title: 'Mark Completed',
          onPress: markComplete,
        },
      ]}
    />
  );
};

export const SingleScreenMessageCompletedTable = ({
  route: {params},
  searchValue,
}) => {
  const {communicationFilter} = params;
  return (
    <Table
      search={searchValue}
      searchFields={'single_screen_message_title'}
      api={`/single-screen-message`}
      addOnFilter={{
        status: 'completed',
        ...communicationFilter,
      }}
      params={params}
      columns={[TITLE, URL, CREATEDON, COMPLETEDON]}
    />
  );
};
